import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import { QuestProvider } from '@questlabs/react-sdk';
import '@questlabs/react-sdk/dist/style.css';
import { AuthProvider } from './context/AuthContext';
import { ServiceProvider } from './context/ServiceContext';
import questConfig from './config/questConfig';
import Header from './components/Header';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import SearchResults from './pages/SearchResults';
import ProviderProfile from './pages/ProviderProfile';
import Categories from './pages/Categories';
import Login from './pages/Login';
import OnboardingPage from './pages/Onboarding';
import JoinAsPro from './pages/JoinAsPro';
import ProDashboard from './pages/ProDashboard';

function App() {
  return (
    <QuestProvider
      apiKey={questConfig.APIKEY}
      entityId={questConfig.ENTITYID}
      apiType="PRODUCTION"
    >
      <AuthProvider>
        <ServiceProvider>
          <Router>
            <div className="min-h-screen bg-gray-50 flex flex-col">
              <Header />
              <motion.main
                className="flex-1"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
              >
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/search" element={<SearchResults />} />
                  <Route path="/categories" element={<Categories />} />
                  <Route path="/provider/:id" element={<ProviderProfile />} />
                  <Route path="/join" element={<JoinAsPro />} />
                  <Route path="/login" element={<Login />} />
                  <Route
                    path="/onboarding"
                    element={
                      <ProtectedRoute>
                        <OnboardingPage />
                      </ProtectedRoute>
                    }
                  />
                  {/* Pro Dashboard - No longer protected, accessible to everyone */}
                  <Route path="/pro/dashboard" element={<ProDashboard />} />
                </Routes>
              </motion.main>
              <Footer />
            </div>
          </Router>
        </ServiceProvider>
      </AuthProvider>
    </QuestProvider>
  );
}

export default App;